<template>
  <div class="additional-service">
    <b-row>
      <b-col cols="6" lg="4">
        <div class="title">Additional Service</div>
      </b-col>
    </b-row>
    <b-card class="b-card-bg">
      <b-row class="px-2">
        <b-col cols="6" lg="4">
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new"
              v-model="value.has_customs"
            />
            <div>
              <div class="text-black">Customs service</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" lg="4">
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new"
              v-model="value.door_service"
              @change="handleChange"
            />

            <div>
              <div class="text-black">Door service</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" lg="4">
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new"
              v-model="value.inland"
              @change="handleChange"
            />

            <div>
              <div class="text-black">Inland trucking in Vietnam</div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="value.has_customs">
        <div class="titleCustom mt-2">Customs Declaration</div>
      </b-row>
      <b-row class="px-2 mt-2" v-if="value.has_customs">
        <b-col cols="6" lg="4">
          <b-row>
            <b-col v-if="value.custom_service_other === false" lg="9">
              <validation-provider
                name="Customs type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Customs type</label>

                  <Select2
                    :disabled="readonly"
                    placeholder="Customs type"
                    v-model="value.customs_type"
                    :options="customs_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col v-if="value.custom_service_other === true" lg="9">
              <validation-provider
                name="Customs type"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Customs type</label>

                  <b-form-input
                    :disabled="readonly"
                    class="iuput"
                    v-model="value.customs_type_input"
                    type="text"
                    placeholder="Customs type"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col lg="3" class="flex items-center mt-1">
              <div class="container-checkbox">
                <input
                  :disabled="readonly"
                  type="checkbox"
                  class="custom-checkbox-new"
                  v-model="value.custom_service_other"
                />

                <div>
                  <div class="text-black">Other</div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6" lg="4">
          <validation-provider
            name="custom place"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Place of Customs declaration</label>

              <b-form-input
                :disabled="readonly"
                class="iuput"
                v-model="value.custom_place"
                type="text"
                placeholder="Place of Customs declaration"
                required
              ></b-form-input>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6" lg="4">
          <validation-provider name="HS Code" #default="{ errors }" rules="">
            <b-form-group>
              <label>HS Code</label>

              <b-form-input
                :disabled="readonly"
                class="iuput"
                v-model="value.custom_hs_code"
                type="text"
                placeholder="HS Code"
                required
              ></b-form-input>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row v-if="value.door_service">
        <div class="titleCustom mt-2">Door service</div>
      </b-row>
      <b-row class="px-2 mt-2" v-if="value.door_service">
        <b-col cols="6" lg="5">
          <validation-provider
            name="Pick up address"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label class="flex"
                >Pick up address <span class="red">*</span></label
              >

              <b-form-input
                :disabled="readonly || value.isPOL_VN"
                class="iuput"
                v-model="value.door_pick_up_input"
                type="text"
                placeholder="Pick up address"
                required
              ></b-form-input>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="0" lg="2"></b-col>
        <b-col cols="6" lg="5">
          <validation-provider
            name="Delivery address"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label class="flex"
                >Delivery address <span class="red">*</span>
              </label>

              <b-form-input
                :disabled="readonly || value.isPOD_VN"
                class="iuput"
                v-model="value.door_delivery_input"
                type="text"
                placeholder="Delivery address"
                required
              ></b-form-input>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col class="mt-2" cols="6" lg="5">
          <b-row>
            <label class="mx-1">Contact person</label>
          </b-row>
          <b-row>
            <b-col class="pr-0" lg="3"
              ><validation-provider
                name="pick_up name"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOL_VN"
                    class="iuput"
                    v-model="value.door_contact_pick_up.name"
                    type="text"
                    placeholder="Name"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
            <b-col class="pr-0" lg="4"
              ><validation-provider
                name="pick_up phone"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOL_VN"
                    class="iuput"
                    v-model="value.door_contact_pick_up.phone"
                    type="text"
                    placeholder="Phone"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
            <b-col lg="5"
              ><validation-provider
                name="pick_up email"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOL_VN"
                    class="iuput"
                    v-model="value.door_contact_pick_up.email"
                    type="text"
                    placeholder="Email"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
          </b-row>
        </b-col>
        <b-col cols="0" lg="2"></b-col>
        <b-col class="mt-2" cols="6" lg="5">
          <b-row>
            <label class="mx-1">Contact person </label>
          </b-row>
          <b-row>
            <b-col class="pr-0" lg="3"
              ><validation-provider
                name="delivery name"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOD_VN"
                    class="iuput"
                    v-model="value.door_contact_delivery.name"
                    type="text"
                    placeholder="Name"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
            <b-col class="pr-0" lg="4"
              ><validation-provider
                name="delivery phone"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOD_VN"
                    class="iuput"
                    v-model="value.door_contact_delivery.phone"
                    type="text"
                    placeholder="Phone"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
            <b-col lg="5"
              ><validation-provider
                name="delivery email"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOD_VN"
                    class="iuput"
                    v-model="value.door_contact_delivery.email"
                    type="text"
                    placeholder="Email"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="value.inland">
        <div class="titleCustom mt-2">Shipment Details</div>
      </b-row>
      <b-row class="px-2 mt-2" v-if="value.inland">
        <b-col cols="12" lg="12">
          <b-row>
            <b-col cols="12" lg="5">
              <b-row>
                <b-col lg="9" class="pr-0" v-if="!value.inland_other1">
                  <validation-provider
                    name="Pick up address"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <label>Pick up address </label>

                      <Select4
                        :key="locationByUser + '123' + load"
                        v-model="value.pickup_location"
                        placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                        :disabled="readonly || value.isPOD_VN"
                        @reload="loadLocation"
                        :options="{
                          isSearch: true,
                          isReload: true,
                          value: 'id',
                          label: 'text',
                          data: locationsPickUp,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col lg="9" class="pr-0" v-if="value.inland_other1">
                  <validation-provider
                    name="Pick up address"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <label>Pick up address</label>

                      <b-form-input
                        :disabled="readonly || value.isPOD_VN"
                        class="iuput"
                        v-model="value.inland_pick_up_input"
                        type="text"
                        placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                        required
                      ></b-form-input>
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col lg="3" class="flex items-center mt-1">
                  <div class="container-checkbox">
                    <input
                      :disabled="readonly || value.isPOD_VN"
                      type="checkbox"
                      class="custom-checkbox-new"
                      v-model="value.inland_other1"
                    />

                    <div>
                      <div class="text-black">Other</div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="0" lg="2"></b-col>
            <b-col cols="12" lg="5">
              <b-row>
                <b-col lg="9" class="pr-0" v-if="!value.inland_other2">
                  <validation-provider
                    name="Delivery address"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <label>Delivery address </label>

                      <Select4
                        :key="locationByUser + '321' + load"
                        v-model="value.delivery_location"
                        placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                        :disabled="readonly || value.isPOL_VN"
                        @reload="loadLocation"
                        :options="{
                          isSearch: true,
                          isReload: true,

                          value: 'id',
                          label: 'text',
                          data: locationsDelivery,
                          fields: [
                            {
                              field: 'abbreviations',
                              label: 'Abbreviations',
                            },
                            {
                              field: 'name',
                              label: 'Location',
                            },
                            {
                              field: 'address',
                              label: 'Address',
                            },
                          ],
                        }"
                      />
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col lg="9" class="pr-0" v-if="value.inland_other2">
                  <validation-provider
                    name="Delivery address"
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-group>
                      <label>Delivery address</label>

                      <b-form-input
                        :disabled="readonly || value.isPOL_VN"
                        class="iuput"
                        v-model="value.inland_delivery_input"
                        type="text"
                        placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                        required
                      ></b-form-input>
                      <small class="text-danger" v-show="errors.length > 0">{{
                        errors[0]
                      }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col lg="3" class="flex items-center mt-1">
                  <div class="container-checkbox">
                    <input
                      :disabled="readonly || value.isPOL_VN"
                      type="checkbox"
                      class="custom-checkbox-new"
                      v-model="value.inland_other2"
                    />

                    <div>
                      <div class="text-black">Other</div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="12" class="mt-1">
          <b-row>
            <b-col cols="12" lg="4">
              <b-row>
                <b-col lg="8" class="pr-0"
                  ><b-form-group>
                    <label>Pick up date</label>
                    <date-picker
                      :disabled="readonly || value.isPOD_VN"
                      ref="datePicker"
                      v-model="value.inland_pick_up_date"
                      type="date"
                      title-format="DD/MM/YY"
                      time-title-format="DD/MM/YY"
                      placeholder="Select date"
                      format="DD/MM/YY"
                      class="w-full"
                      value-type="format"
                    >
                    </date-picker> </b-form-group
                ></b-col>
                <b-col lg="4" class="mt-24"
                  ><b-form-group>
                    <date-picker
                      :disabled="readonly || value.isPOD_VN"
                      v-model="value.inland_pick_up_time"
                      ref="datePicker"
                      type="time"
                      title-format="HH:mm"
                      time-title-format="HH:mm"
                      placeholder="Select time"
                      format="HH:mm"
                      class="w-full"
                      value-type="format"
                    >
                    </date-picker> </b-form-group
                ></b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="3"></b-col>
            <b-col cols="12" lg="4">
              <b-row>
                <b-col lg="8" class="pr-0"
                  ><b-form-group>
                    <label>Delivery date</label>
                    <date-picker
                      :disabled="readonly || value.isPOL_VN"
                      ref="datePicker"
                      v-model="value.inland_delivery_date"
                      type="date"
                      title-format="DD/MM/YY"
                      time-title-format="DD/MM/YY"
                      placeholder="Select date"
                      format="DD/MM/YY"
                      class="w-full"
                      value-type="format"
                    >
                    </date-picker> </b-form-group
                ></b-col>
                <b-col lg="4" class="mt-24"
                  ><b-form-group>
                    <label></label>
                    <date-picker
                      :disabled="readonly || value.isPOL_VN"
                      v-model="value.inland_delivery_time"
                      ref="datePicker"
                      type="time"
                      title-format="HH:mm"
                      time-title-format="HH:mm"
                      placeholder="Select time"
                      format="HH:mm"
                      class="w-full"
                      value-type="format"
                    >
                    </date-picker></b-form-group
                ></b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" class="mt-1" lg="4"
          ><b-row>
            <label class="mx-1">Contact person</label>
          </b-row>
          <b-row>
            <b-col class="pr-0" lg="3"
              ><validation-provider
                name="inland_pick_up name"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOD_VN"
                    class="iuput"
                    v-model="value.inland_contact_pick_up.name"
                    type="text"
                    placeholder="Name"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
            <b-col class="pr-0" lg="4"
              ><validation-provider
                name="inland_pick_up phone"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOD_VN"
                    class="iuput"
                    v-model="value.inland_contact_pick_up.phone"
                    type="text"
                    placeholder="Phone"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
            <b-col lg="5"
              ><validation-provider
                name="inland_pick_up email"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOD_VN"
                    class="iuput"
                    v-model="value.inland_contact_pick_up.email"
                    type="text"
                    placeholder="Email"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
          </b-row>
        </b-col>
        <b-col lg="3"></b-col>
        <b-col cols="12" class="mt-1" lg="4"
          ><b-row>
            <label class="mx-1">Contact person </label>
          </b-row>
          <b-row>
            <b-col class="pr-0" lg="3"
              ><validation-provider
                name="inland_contact_delivery name"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOL_VN"
                    class="iuput"
                    v-model="value.inland_contact_delivery.name"
                    type="text"
                    placeholder="Name"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
            <b-col class="pr-0" lg="4"
              ><validation-provider
                name="inland_contact_delivery phone"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOL_VN"
                    class="iuput"
                    v-model="value.inland_contact_delivery.phone"
                    type="text"
                    placeholder="Phone"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
            <b-col lg="5"
              ><validation-provider
                name="inland_contact_delivery email"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <b-form-input
                    :disabled="readonly || value.isPOL_VN"
                    class="iuput"
                    v-model="value.inland_contact_delivery.email"
                    type="text"
                    placeholder="Email"
                    required
                  ></b-form-input>
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider></b-col
            >
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="checkbox-bottom">
      <b-row class="px-2 custom-row">
        <b-col>
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new-bottom"
              id="checkbox-1"
              v-model="value.insurance"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />

            <div>
              <div class="text-black">Insurance</div>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new-bottom"
              id="checkbox-1"
              v-model="value.packaging"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />

            <div>
              <div class="text-black">Packaging</div>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new-bottom"
              id="checkbox-1"
              v-model="value.labeling"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />

            <div>
              <div class="text-black">Labeling</div>
            </div>
          </div>
        </b-col>

        <b-col>
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new-bottom"
              id="checkbox-1"
              v-model="value.securing_of_load"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />

            <div>
              <div class="text-black">Fumigation</div>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new-bottom"
              id="checkbox-1"
              v-model="value.liquidation"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />

            <div>
              <div class="text-black">Liquidation</div>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new-bottom"
              id="checkbox-1"
              v-model="value.commodity_policy"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />

            <div>
              <div class="text-black">Commodity policy advisory</div>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="container-checkbox">
            <input
              :disabled="readonly"
              type="checkbox"
              class="custom-checkbox-new-bottom"
              id="checkbox-1"
              v-model="value.weighing"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />

            <div>
              <div class="text-black">Weighing</div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import { BFormGroup, BRow, BCol, BCard } from "bootstrap-vue";
export default {
  components: {
    Select2,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BRow,
    BCol,
    BCard,
  },
  props: {
    value: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      load: 1,
      isCheckedCustom: false,
      isCheckedDoor: false,
      isCheckedInland: false,
      R: true,
      valuePerson_pick_up: null,
      valuePerson_delivery: null,
    };
  },
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",

      "locationByUser",
    ]),

    locationsPickUp: function () {
      if (
        (this.value.isPOD_VN || this.value.isPOL_VN) &&
        this.$Utils.LCL_PICKUP_DELIVERY_POL_POD[
          this.value.isPOD_VN ? "1" : this.value.isPOL_VN ? "3" : ""
        ]
      ) {
        return this.locationByUser?.filter((e) =>
          this.$Utils.LCL_PICKUP_DELIVERY_POL_POD[
            this.value.isPOD_VN ? "1" : this.value.isPOL_VN ? "3" : ""
          ].includes(e.location_type_id.toString())
        );
      }

      return [];
    },
    locationsDelivery: function () {
      if (
        (this.value.isPOD_VN || this.value.isPOL_VN) &&
        this.$Utils.LCL_PICKUP_DELIVERY_POL_POD[
          this.value.isPOD_VN ? "2" : this.value.isPOL_VN ? "4" : ""
        ]
      ) {
        return this.locationByUser?.filter((e) =>
          this.$Utils.LCL_PICKUP_DELIVERY_POL_POD[
            this.value.isPOD_VN ? "2" : this.value.isPOL_VN ? "4" : ""
          ].includes(e.location_type_id.toString())
        );
      }
      return [];
    },
  },
  created() {},
  methods: {
    handleChange() {
      if (this.value.door_service) {
        this.value.has_d2d_trucking = true;
      } else {
        this.value.has_d2d_trucking = false;
      }
      if (this.value.inland) {
        this.value.has_van_trucking = true;
      } else {
        this.value.has_van_trucking = false;
      }
    },
    loadLocation() {
      if (!this.value.customer_id) {
        return;
      }

      this.$store.dispatch("masterData/fetchLocationByUser", {
        customer_id: this.value.customer_id,
      });
      this.load++;
    },
  },
  watch: {
    "value.delivery_location": function (n, o) {
      this.valuePerson_delivery = this.locationByUser.filter(
        (item) => item.id === n
      )[0];

      if (this.valuePerson_pick_up) {
        this.value.inland_contact_pick_up.name =
          this.valuePerson_pick_up.contact_name || "";
        this.value.inland_contact_pick_up.phone =
          this.valuePerson_pick_up.contact_phone || "";
        this.value.inland_contact_pick_up.email =
          this.valuePerson_pick_up.contact_email || "";
      } else {
        // Xử lý khi valuePerson_pick_up là undefined
      }
    },
    "value.pickup_location": function (n, o) {
      this.valuePerson_pick_up = this.locationByUser.filter(
        (item) => item.id === n
      )[0];
      if (this.valuePerson_pick_up) {
        this.value.inland_contact_pick_up.name =
          this.valuePerson_pick_up.contact_name || "";
        this.value.inland_contact_pick_up.phone =
          this.valuePerson_pick_up.contact_phone || "";
        this.value.inland_contact_pick_up.email =
          this.valuePerson_pick_up.contact_email || "";
      } else {
        // Xử lý khi valuePerson_pick_up là undefined
      }
    },
  },
};
</script>

<style lang="scss">
.additional-service {
  height: auto;
  position: relative;
  z-index: 10;

  .mt-24 {
    margin-top: 24px;
  }

  .checkbox-bottom {
    z-index: 1;
    position: absolute;
    height: 150px;
    width: 100%;
    bottom: -125px;

    @media (max-width: 992px) {
      height: 250px;
      width: 100%;
      bottom: -220px;
    }

    .custom-row {
      display: grid;
      grid-template-columns: 2fr 2fr 2fr 2fr 2fr 3fr 2fr;
      width: 100%;
      position: absolute;
      bottom: 30px;

      @media (max-width: 992px) {
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  .custom-row {
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 10px;

    @media (max-width: 992px) {
      height: 150px;
      gap: 0px;
      justify-content: unset;
    }
  }

  .container-checkbox {
    width: 100%;
    display: flex;
    gap: 5px;
    justify-items: center;
    align-items: center;
  }

  .titleCustom {
    font-size: 1.3rem;
    margin-left: 35px;
    color: #28938d !important;
    font-weight: 600;
  }

  label {
    color: #000000;
    font-weight: 600;
  }

  .b-card-bg {
    padding: 15px 0;
    z-index: 10;
    height: auto;

    @media (max-width: 992px) {
      height: 200px;
    }
  }

  //   .select2 {
  //     height: 28px !important;
  //   }
  .select2-selection .select2-selection--single {
    border: none !important;
  }

  .select2-container--default .select2-selection--single {
    border: none !important;
  }

  .select2-selection--single:before {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=") !important;
  }

  .mx-input {
    border: none !important;
  }

  .form-control {
    border: none !important;
  }
}
</style>
